<template>
    <div class="container">
        <div class="row mb-3">
            <div class="col-7 text-dark d-flex align-items-center">
                <small>Tanzen & Friends Srl © 2023</small>
            </div>
            <div class="col-5 text-dark d-flex align-items-end">
                <div class="text-right w-100 social-footer">
                    <a href="https://garage.pizza/lievitamente/gruppofacebook" target="_blank">
                        <font-awesome-icon class="mr-3" :icon="['fab', 'facebook']" />
                    </a>
                    <a href="https://twitter.com/Tanzen" target="_blank">
                        <font-awesome-icon class="mr-3" :icon="['fab', 'twitter']" />
                    </a>
                    <a href="https://www.instagram.com/lievitamente.pizza/" target="_blank">
                        <font-awesome-icon :icon="['fab', 'instagram']" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
  name: 'EndSite'
}
</script>

<style>
footer {
    height: 310px;
    background-image: url(../assets/path_white.png);
    background-position: 0px -135px;
}
.social-footer {
    font-size: 24px;;
}
</style>


// WEBPACK FOOTER //
// src/components/EndSite.vue